var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.647,
    style: {
      fill: "#B92727"
    },
    width: 264.683,
    height: 23.554
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.955,
    y: 159.998,
    style: {
      fill: "#E9A65E"
    },
    width: 400.087,
    height: 313.306
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.955,
    y: 396.89,
    style: {
      fill: "#D97A2B"
    },
    width: 400.087,
    height: 69.182
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#936B49"
    },
    d: "M475.222,505.025c0,3.853-3.123,6.975-6.975,6.975H43.754c-3.853,0-6.975-3.123-6.975-6.975v-31.98 c0-3.853,3.123-6.975,6.975-6.975h424.492c3.853,0,6.975,3.123,6.975,6.975V505.025z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.539,
    y: 222.023,
    style: {
      fill: "#6B4F37"
    },
    width: 137.204,
    height: 244.056
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.878,
    y: 244.527,
    style: {
      fill: "#826041"
    },
    width: 100.537,
    height: 91.525
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.878,
    y: 358.362,
    style: {
      fill: "#826041"
    },
    width: 100.537,
    height: 91.525
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#423223"
    },
    cx: 393.424,
    cy: 318.05,
    r: 9.502
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.24,
    y: 222.023,
    style: {
      fill: "#6B4F37"
    },
    width: 198.035,
    height: 151.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.059,
    y: 228.268,
    style: {
      fill: "#C7D7DC"
    },
    width: 180.392,
    height: 138.499
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "157.477,366.781 125.696,366.781 185.615,228.268 217.396,228.268 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "199.041,366.781 176.301,366.781 236.216,228.268 258.959,228.268 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "108.929,366.781 97.555,366.781 157.474,228.268 168.844,228.268 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA3F3F"
    },
    d: "M176.462,18.167h-52.789L38.656,159.998c0,24.772,19.419,44.854,43.374,44.854 s43.374-20.082,43.374-44.854h-0.04L176.462,18.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA3F3F"
    },
    d: "M388.323,18.167h-52.789l51.103,141.831H386.6c0,24.772,19.419,44.854,43.374,44.854 s43.374-20.082,43.374-44.854L388.323,18.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA3F3F"
    },
    d: "M282.719,18.167h-26.721h-26.717l-17.168,141.831h0.511c0,24.772,19.419,44.854,43.374,44.854 s43.374-20.082,43.374-44.854h0.511L282.719,18.167z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE9DE"
    },
    d: "M229.281,18.167h-52.819l-51.103,141.831h0.279c0,24.772,19.419,44.854,43.374,44.854 s43.374-20.082,43.374-44.854h-0.273L229.281,18.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE9DE"
    },
    d: "M335.534,18.167h-52.815l17.168,141.831h-0.273c0,24.772,19.419,44.854,43.374,44.854 c23.955,0,43.374-20.082,43.374-44.854h0.279L335.534,18.167z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92727"
    },
    d: "M82.026,204.852c23.955,0,43.374-20.082,43.374-44.854H38.653 C38.656,184.773,58.075,204.852,82.026,204.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD5CA"
    },
    d: "M169.016,204.852c23.955,0,43.374-20.082,43.374-44.854h-86.747 C125.642,184.773,145.061,204.852,169.016,204.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92727"
    },
    d: "M255.998,204.852c23.955,0,43.374-20.082,43.374-44.854h-86.747 C212.625,184.773,232.044,204.852,255.998,204.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD5CA"
    },
    d: "M342.984,204.852c23.955,0,43.374-20.082,43.374-44.854h-86.744 C299.614,184.773,319.033,204.852,342.984,204.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B92727"
    },
    d: "M429.97,204.852c23.955,0,43.374-20.082,43.374-44.854H386.6 C386.6,184.773,406.016,204.852,429.97,204.852z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 105,
    y: 230,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M9.968 0v8.6c0 1.714-.64 3.175-2.471 3.175S5.029 10.313 5.029 8.6V0H0v9.014c0 3.465 2.42 6.638 7.5 6.638S15 12.479 15 9.014V0z",
    transform: "translate(116.244 22.217)",
    style: {
      fill: "#df0011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 3",
    d: "M13.7 21.13V12.3H5.242v8.83H0V0h5.242v8H13.7V0h5.241v21.13z",
    transform: "translate(1 15.956)",
    style: {
      fill: "#df0011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 5",
    d: "M8.273 16.435A8.358 8.358 0 0 1 2.45 14.19a7.692 7.692 0 0 1-1.79-2.609A8.817 8.817 0 0 1 0 8.156a7.933 7.933 0 0 1 2.45-5.974A8.458 8.458 0 0 1 8.273 0a8.509 8.509 0 0 1 5.85 2.182 7.922 7.922 0 0 1 2.454 5.974 8.807 8.807 0 0 1-.661 3.425 7.681 7.681 0 0 1-1.793 2.609 8.408 8.408 0 0 1-5.85 2.245zM8.258 3.913a3.272 3.272 0 0 0-2.63 1.207 4.232 4.232 0 0 0-.892 2.68 4.362 4.362 0 0 0 .907 2.7 3.286 3.286 0 0 0 2.645 1.238 3.285 3.285 0 0 0 2.645-1.238 4.364 4.364 0 0 0 .907-2.7 3.631 3.631 0 0 0-3.582-3.887z",
    transform: "translate(22.312 22.217)",
    style: {
      fill: "#df0011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 7",
    d: "M19.453 15.652V7.337c0-1.742-.4-3.208-2.172-3.208-1.713 0-2.538 1.589-2.538 3.3v8.223H9.727v-8.68c0-1.744-.675-2.844-2.173-2.844-1.589 0-2.508 1.437-2.508 3.268v8.255H0V.428h4.862v2.109h.061A5.1 5.1 0 0 1 9.482 0a4.794 4.794 0 0 1 4.587 2.6A5.447 5.447 0 0 1 18.932 0c4.13 0 5.538 3.363 5.538 6.236v9.416z",
    transform: "translate(42.046 22.217)",
    style: {
      fill: "#df0011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 9",
    d: "M8.335 16.435a8.624 8.624 0 0 1-5.878-2.125A7.919 7.919 0 0 1 0 8.28a8.2 8.2 0 0 1 2.369-6.036A8.225 8.225 0 0 1 8.182 0c4.62 0 7.6 3.3 7.6 8.4 0 .412 0 .838-.031 1.208H4.775a3.486 3.486 0 0 0 3.625 2.92 3.929 3.929 0 0 0 3.274-1.519l3.458 2.254a7.891 7.891 0 0 1-6.797 3.172zM8.118 3.13a3.366 3.366 0 0 0-3.382 3.13h6.314a3.258 3.258 0 0 0-.8-2.278 2.833 2.833 0 0 0-2.132-.852z",
    transform: "translate(69.673 22.217)",
    style: {
      fill: "#df0011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 11",
    d: "M10.65 5.054a4.763 4.763 0 0 0-3.2-1.394c-.955 0-1.91.34-1.91 1.24 0 .868.831 1.118 2.8 1.549 2.342.529 4.9 1.708 4.9 4.715 0 3.9-3.415 5.271-6.557 5.271A9.845 9.845 0 0 1 0 14.047l2.83-3.008a5.2 5.2 0 0 0 3.756 1.737c.832 0 1.817-.342 1.817-1.333 0-.962-.955-1.271-3.047-1.769C3.229 9.177.892 8.092.892 5.178.892 1.488 4.338 0 7.264 0a9.151 9.151 0 0 1 6.155 2.172z",
    transform: "translate(133.61 22.217)",
    style: {
      fill: "#df0011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 13",
    d: "M0 21.913h4.736V0H0z",
    transform: "translate(107.562 15.174)",
    style: {
      fill: "#df0011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 15",
    d: "M4.908 21.913H0V.428h4.668v1.863h.089A5.877 5.877 0 0 1 9.515 0a6.719 6.719 0 0 1 2.934.649 6.636 6.636 0 0 1 2.224 1.745 8.67 8.67 0 0 1 1.9 5.578 8.926 8.926 0 0 1-1.863 5.636 6.52 6.52 0 0 1-5.23 2.454 5.534 5.534 0 0 1-4.518-2.107h-.054v7.958zm3.425-18A3.4 3.4 0 0 0 5.7 5.148a4.225 4.225 0 0 0 0 5.38 3.4 3.4 0 0 0 2.63 1.212c1.689 0 3.507-1.234 3.507-3.943.003-1.871-1.094-3.884-3.504-3.884z",
    transform: "translate(88.617 22.217)",
    style: {
      fill: "#df0011"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreHouse);
export default __webpack_public_path__ + "static/media/store_house.4770828aa0784331aa81f46a4acc9d7b.svg";
export { ForwardRef as ReactComponent };